import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=5dd67708&scoped=true&"
import script from "./BaseBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=5dd67708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd67708",
  null
  
)

export default component.exports